// node_modules
import { FC } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
// Types
import { TTechnology } from "Types";
// styles
import styles from './technologyRatesSummaryIcon.module.scss';

type TTechnologyRatesSummaryIconProps = {
    technology: TTechnology,
    noRateNotification?: Boolean,
    isOutsideSidebar?: boolean,
}

export const TechnologyRatesSummaryIcon: FC<TTechnologyRatesSummaryIconProps> = ({technology, noRateNotification, isOutsideSidebar}: TTechnologyRatesSummaryIconProps) => {
    const getPercentagePoint = (): number => {
        if (!technology.rates) return 0;
        return (Math.round((technology.rates.averageRate * 100) / 5) - 100) * (-1);
    }

    return (
        <span className="fa-layers fa-fw" style={{minWidth: "1.25rem"}}>
            {technology.rates && (technology.rates.currentUserRate || (technology.rates.userRates && technology.rates.userRates.length >= 1)) ?
                    <FontAwesomeIcon icon={faStar} className={[styles.technologyVotesSummaryVoted, isOutsideSidebar ? styles.isOutsideSidebar : ""].join(" ")} />
                :
                    <FontAwesomeIcon icon={faStar} className={styles.fontAwesomeItem} />
            }
            {technology.rates && (technology.rates.currentUserRate || (technology.rates.userRates && technology.rates.userRates.length >= 1)) ?
                    <FontAwesomeIcon 
                        style={{clipPath: technology.rates.averageRate > 4.99 ? "" : `inset(0 ${getPercentagePoint()}% 0 0)`}}
                        className={styles.technologyRatesSummaryIcon} 
                        icon={faStar} />
                : 
                    null
            }
            {noRateNotification && (!technology.rates || !technology.rates.currentUserRate) ? 
                    <div className={[styles.technologyNoRateNotification, isOutsideSidebar ? styles.isOutsideSidebar : ""].join(" ")}></div>
                :
                    null
            }
        </span>
    );
}